import styled from 'styled-components';

export const ModalOverlay = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    z-index: 10001;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
`;

export const ModalContainer = styled.div`
    background: var(--bg-color);
    color: var(--text-cor);
    border-radius: 0.4rem;
    width: 100%;
    max-width: 92rem;
    max-height: 85vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
`;

export const ModalHeader = styled.div`
    padding: 1.6rem 2rem;
    border-bottom: 1px solid var(--bg-hover-light);
    display: flex;
    align-items: center;
    justify-content: space-between;

    h2 {
        margin: 0;
        font-size: 1.8rem;
    }

    button {
        border: none;
        background: transparent;
        cursor: pointer;
        color: var(--btn-admin-icone);
        font-size: 2.2rem;
        line-height: 1;
    }
`;

export const ModalContent = styled.div`
    padding: 1.6rem 2rem 2rem;
    overflow-y: auto;
`;

export const DetailItem = styled.div`
    margin-bottom: 1rem;

    strong {
        display: block;
        margin-bottom: 0.4rem;
    }

    span {
        word-break: break-word;
    }
`;

export const JsonBlock = styled.pre`
    margin: 0;
    padding: 1rem;
    background: var(--bg-hover-light);
    border-radius: 0.4rem;
    white-space: pre-wrap;
    word-break: break-word;
    max-height: 24rem;
    overflow: auto;
`;
